import React, { Component } from 'react';
import styles from './css/PasswordStrengthMeter.scss';
import zxcvbn from 'zxcvbn';

class PasswordStrengthMeter extends Component {

    createPasswordLabel = (result) => {
        switch (result.score) {
        case 0:
            return 'none';
        case 1:
            return 'weak';
        case 2:
            return 'fair';
        case 3:
            return 'good';
        case 4:
            return 'strong';
        default:
            return 'weak';
        }
    };

    render() {
        const { password } = this.props;
        const testedResult = zxcvbn(password);
        const styleClass = password.length > 0 ? styles[`password-strength-meter-progress`] + ' ' + styles[`strength-${this.createPasswordLabel(testedResult)}`] : styles[`password-strength-meter-progress`];
        return (
            <div
                className={styleClass}
                value={testedResult.score}
                max={4}
            />
        );
    }
}

export default PasswordStrengthMeter;
